import React from "react";
import "../styles/DownloadSection.css";

export default function DownloadSection({
  url,
  setUrl,
  loading,
  handleDownload,
  showModal,
  downloadLink,
  onCloseModal,
}) {
  return (
    <div className="download-section">
      <h3>Envato Elements Download</h3>
      <input
        type="text"
        placeholder="Example: https://elements.envato.com/..."
        value={url}
        onChange={(e) => setUrl(e.target.value)}
        disabled={loading}
      />
      <p className="note">
        Only URLs from elements.envato.com domain are accepted
      </p>

      <button
        className="download-btn"
        onClick={handleDownload}
        disabled={loading}
      >
        {loading ? (
          <>
            <span className="spinner" /> Downloading...
          </>
        ) : (
          "Download"
        )}
      </button>

     {showModal && (
  <div className="modal-backdrop">
    <div className="modal">
      <div className="modal-icon">✅</div>
      <h2>🎉 Download Completed!</h2>
      <p>Your file is ready for download.</p>
      <a
        href={downloadLink}
        target="_blank"
        rel="noopener noreferrer"
        className="btn-success"
      >
        ⬇ Download File
      </a>
      <button className="btn-close" onClick={onCloseModal}>
        Close
      </button>
    </div>
  </div>
)}

    </div>
  );
}
